import styled from 'styled-components';

export default styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--grey500);
`;
